
import React from 'react';
import { cn } from '@/lib/utils';
import './ModeSelector.css';

interface ModeOption {
  label: string;
  value: 'agentic' | 'fe';
}

interface ModeSelectorProps {
  value: 'agentic' | 'fe';
  onChange: (value: 'agentic' | 'fe') => void;
  disabled?: boolean;
  className?: string;
}

const ModeSelector: React.FC<ModeSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  className
}) => {
  const modes: ModeOption[] = [
    { label: 'Agentic', value: 'agentic' },
    { label: 'Feature Extraction', value: 'fe' }
  ];

  return (
    <div className={cn('mode-selector-wrapper', disabled && 'mode-selector-disabled', className)}>
      <div className="mode-selector-container">
        {modes.map((mode) => (
          <button
            key={mode.value}
            type="button"
            className={cn(
              'mode-selector-option',
              value === mode.value && 'mode-selector-option-active'
            )}
            onClick={() => !disabled && onChange(mode.value)}
            disabled={disabled}
          >
            {mode.label}
          </button>
        ))}
        <div
          className={cn(
            'mode-selector-indicator',
            value === 'fe' && 'mode-selector-indicator-right'
          )}
        />
      </div>
    </div>
  );
};

export default ModeSelector;
